import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import XtLoading from "@/components/Xt/Loading";
import { Form, Input, InputNumber, Checkbox, message } from "antd";
import CountryDropdown from "@/components/App/CountryDropdown";
import XtBtntxt from "@/components/Xt/BtnTxt";
import { waitRes } from "@/utils/axios";
import { post_enterprise, post_enterpriseSaveDraft, get_enterpriseInfo } from "@/api/xt-user";
interface P1Props extends BaseCompProps {
  attr?: any;
  enterpriseApplyId?: string;
  onStepChange?(step: number): void;
}
const { useTranslation } = Hooks;
const { useForm } = Form;
const initFormData = {
  name: "", //公司注册名称
  code: "", //公司注册编号
  mobileCountryId: "", //商务联系电话code
  mobile: "", //商务联系电话
  nature: "", //业务性质
  fundSource: "", //资金来源
  monthTradeAmount: "", //预计平均每月交易量，int
  registerCountryId: "", //注册国家/地区
  registerCity: "", //注册城市
  registerStreet: "", //注册街道
  businessCountryId: "", //经营国家/地区
  businessCity: "", //经营城市
  businessStreet: "", //经营街道
};
export type FormDataType = typeof initFormData;
const P1: React.FC<P1Props> = ({ className, enterpriseApplyId, onStepChange }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initFormData });
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  /** useEffect */
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    formIns.setFieldsValue({ ...formData });
  }, [formData]);
  /**useMemo */
  const rules = useMemo(() => {
    return {
      name: [{ required: true, message: t("ent.plsInput") }],
      code: [{ required: true, message: t("ent.plsInput") }],
      mobile: [
        { required: true, message: t("ent.plsInput") },
        { pattern: /^[0-9]+$/, message: t("ent.inputError") },
      ],
      nature: [{ required: true, message: t("ent.plsInput") }],
      fundSource: [{ required: true, message: t("ent.plsInput") }],
      monthTradeAmount: [{ required: true, message: t("ent.plsInput") }],
      registerCity: [{ required: true, message: t("ent.plsInput") }],
      registerStreet: [{ required: true, message: t("ent.plsInput") }],
      businessCity: [{ required: true, message: t("ent.plsInput") }],
      businessStreet: [{ required: true, message: t("ent.plsInput") }],
    };
  }, []);
  /**method */
  const init = async () => {
    setLoading(true);
    const { data, err } = await waitRes(get_enterpriseInfo, {
      params: {
        enterpriseApplyId,
      },
    });
    setLoading(false);
    if (err || !data) return;
    setFormData({ ...data, id: data.id });
  };
  const onValuesChange = (changedValue: FormDataType, allValues: FormDataType) => {
    const data = { ...formData, ...changedValue };
    setFormData(data);
  };

  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      const data = { ...formData, businessCountryId: formData.registerCountryId, businessCity: formData.registerCity, businessStreet: formData.registerStreet };
      setFormData(data);
    }
  };

  const onSaveDraft = async () => {
    setLoading(true);
    const { data, err } = await waitRes(post_enterpriseSaveDraft, {
      errorPop: true,
      params: { enterpriseApplyId },
      data: {
        ...formData,
        id,
      },
    });
    setLoading(false);
    if (err) return;
    message.success(t("ent.saveSuccess"));
  };
  const onSaveContinue = async () => {
    try {
      const values = await formIns.validateFields();
      setLoading(true);
      const { data, err } = await waitRes(post_enterprise, {
        errorPop: true,
        params: { enterpriseApplyId },
        data: {
          ...formData,
          id,
        },
      });
      setLoading(false);
      if (err) return;
      onStepChange && onStepChange(2);
    } catch (error) {
      message.error(t("ent.errTip"));
    }
  };
  return (
    <div className={cx(styles["page-account-enterprise-p1"], className)}>
      <Form name="p1Form" form={formIns} initialValues={formData} onValuesChange={onValuesChange} layout="vertical">
        {/* 机构信息 */}
        <div>
          <div className={styles["page-account-enterprise--title"]}>{t("ent.instInfo")}</div>
          <div className={styles["page-account-enterprise--form"]}>
            <section>
              <Form.Item name={"name"} label={t("ent.comRgName")} rules={rules.name}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>

              <Form.Item label={t("ent.busConTel")}>
                <div className={styles["tel-ctn"]}>
                  <CountryDropdown
                    selectProps="id"
                    value={+formData.mobileCountryId}
                    label={(item) => (
                      <>
                        <span>+</span>&nbsp;
                        <span style={{ fontSize: "13px" }}>{item?.code || t("cmpt.select")}</span>
                      </>
                    )}
                    onChange={(value) => {
                      setFormData({ ...formData, mobileCountryId: value + "" });
                    }}
                  />
                  <Form.Item name={"mobile"} rules={rules.mobile} noStyle>
                    <Input type="tel" placeholder={t("ent.plsInput")} maxLength={16} />
                  </Form.Item>
                </div>
              </Form.Item>

              <Form.Item name={"fundSource"} label={t("ent.fundSource")} rules={rules.fundSource}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
            </section>
            <div className={styles["page-account-enterprise--formSplit"]}></div>
            <section>
              <Form.Item name={"code"} label={t("ent.comRgCode")} rules={rules.code}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
              <Form.Item name={"nature"} label={t("ent.busType")} rules={rules.nature}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
              <Form.Item name={"monthTradeAmount"} label={t("ent.monthTradeAmount")} rules={rules.monthTradeAmount}>
                <InputNumber
                  placeholder={t("ent.plsInput")}
                  min={1}
                  max={1e15 - 1}
                  precision={0}
                  autoComplete="new-text"
                  style={{ width: "100%" }}
                ></InputNumber>
              </Form.Item>
            </section>
          </div>
        </div>
        {/* 公司注册地址 */}
        <div>
          <div className={styles["page-account-enterprise--title"]}>{t("ent.comRegAddr")}</div>
          <div className={styles["page-account-enterprise--form"]}>
            <section>
              <Form.Item label={t("ent.comRegCountryArea")}>
                <CountryDropdown
                  selectProps="id"
                  value={+formData.registerCountryId}
                  onChange={(value) => {
                    setFormData({ ...formData, registerCountryId: value + "" });
                  }}
                />
              </Form.Item>
              <Form.Item name={"registerStreet"} label={t("ent.comRegStreet")} rules={rules.registerStreet}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
            </section>
            <div className={styles["page-account-enterprise--formSplit"]}></div>
            <section>
              <Form.Item name={"registerCity"} label={t("ent.comRegCity")} rules={rules.registerCity}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
            </section>
          </div>
        </div>
        {/* 公司经营地址 */}
        <div>
          <div className={styles["iTitle"]}>
            <b>{t("ent.comBusAddr")}</b>
            <Checkbox onChange={onCheckBoxChange}>{t("ent.sameSignAddr")}</Checkbox>
          </div>
          <div className={styles["page-account-enterprise--form"]}>
            <section>
              <Form.Item label={t("ent.comBusCountryArea")}>
                <CountryDropdown
                  selectProps="id"
                  value={+formData.businessCountryId}
                  onChange={(value) => {
                    setFormData({ ...formData, businessCountryId: value + "" });
                  }}
                />
              </Form.Item>
              <Form.Item name={"businessStreet"} label={t("ent.comBusStreet")} rules={rules.businessStreet}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
            </section>
            <div className={styles["page-account-enterprise--formSplit"]}></div>
            <section>
              <Form.Item name={"businessCity"} label={t("ent.comBusCity")} rules={rules.businessCity}>
                <Input placeholder={t("ent.plsInput")} maxLength={50} autoComplete="new-text"></Input>
              </Form.Item>
            </section>
          </div>
        </div>

        <div className={styles["page-account-enterprise--btns"]}>
          <XtBtntxt className={styles["ghost"]} onClick={onSaveDraft}>
            {t("ent.saveDraft")}
          </XtBtntxt>
          <XtBtntxt onClick={onSaveContinue}>{t("ent.saveContinue")}</XtBtntxt>
        </div>
      </Form>
      {loading && <XtLoading />}
    </div>
  );
};
export default observer(P1);
